var map = {
	"./tool.js": "8vCD",
	"./window.js": "gNvj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UuJg";


//////////////////
// WEBPACK FOOTER
// ./src/methods nonrecursive \.js|\.vue$
// module id = UuJg
// module chunks = 75